import { createSelector } from 'reselect'

const getproductTagsOptions: SelectOptionsSelector = (state) =>
  state.productTags.productTagsForOptions.map((item) => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const productTagsSelectOptionsSelector: SelectOptionsSelector = createSelector(getproductTagsOptions, (options) => options)
